<template>
  <div
    class="filter-toggle-wrapper"
    :class="{ disabled: isDisabled }"
    @click="$emit('update:modelValue', !modelValue)"
  >
    <span class="filter-toggle-text">
      {{ label }}
    </span>
    <span
      class="filter-toggle-dot"
      :class="{ enabled: modelValue }"
    >
      <CheckMarkIcon />
    </span>
  </div>
</template>

<script setup>
import CheckMarkIcon from '@/assets/icon_checkmark_small.svg?component';

defineProps({
  isDisabled: { type: Boolean, default: false },
  label: { type: String, default: '' },
  modelValue: { type: Boolean, default: false },
});

defineEmits(['update:modelValue']);

</script>

<style scoped lang="less">
.filter-toggle-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 16px;
  border-radius: 20px;
  background: @white;

  &:hover {
    cursor: pointer;
    background: @bg-canvas;
    transition: background 300ms ease-in;
  }

  &.disabled {
    pointer-events: none;
    opacity: 0.3;
  }
}

.filter-toggle-text {
  font-size: 14px;
  font-weight: 400;
  line-height: 12px;
  color: @text-darkest;
  margin-right: 4px;
}

.filter-toggle-dot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: @grey-400;

  &.enabled {
    background: @basic-green;
  }
}
</style>
